import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useDocTransmittalContext } from "../DocTransmittal.context";
import { getCompanyCustomers, getCompanyVendors } from "../api";
import { Button, ListItemIcon, ListItemText, Typography } from "@mui/material";

import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import PersonIcon from "@mui/icons-material/Person";

export default function ReceiverForm() {
  const { newDoc, setNewDoc } = useDocTransmittalContext();

  const [receivers, setReceivers] = React.useState([]);

  React.useEffect(() => {
    const getReceivers = async () => {
      if (newDoc.receiverType === "Client") {
        const res = await getCompanyCustomers();
        setReceivers(res);
      } else {
        const res = await getCompanyVendors();
        setReceivers(res);
      }
    };

    getReceivers();
  }, [newDoc.receiverType]);

  const onChange = (e) => {
    setNewDoc({
      ...newDoc,
      receiver: receivers.find((r) => r.id === e.target.value),
    });
  };
  return (
    <Box sx={{ display: "flex", gap: 2 }}>
      <Box sx={{ width: 620 }}>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">
            {newDoc.receiverType}
          </InputLabel>
          <Select
            value={newDoc?.receiver?.id}
            label={newDoc.receiverType}
            onChange={onChange}
          >
            {receivers.map((r) => {
              return (
                <MenuItem value={r.id} key={r.id}>
                  {/* <ListItemIcon>
                    <PersonIcon fontSize="small" />
                  </ListItemIcon> */}
                  <ListItemText>{r.name}</ListItemText>
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    {r.email}
                  </Typography>
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Box>

      <Button sx={{ flexGrow: 1 }} variant="outlined">
        Send To New {newDoc.receiverType}
      </Button>
    </Box>
  );
}
